export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: "dashboard-390313",
  storageBucket: "dashboard-390313.appspot.com",
  messagingSenderId: "159313331981",
  appId: "1:159313331981:web:72dd23465816fa3ae71244",
  measurementId: "G-PYDN2D45FP",
}

export const graphqlEndpoint = import.meta.env.VITE_GRAPHQL_ENDPOINT ?? "dashboard"

// Legacy StepZen endpoint
export const graphqlUriLegacy = `${import.meta.env.VITE_GRAPHQL_HOST}/api/${graphqlEndpoint}/__graphql`
export const graphqlUri = graphqlUriLegacy // Backward compatibility

// Primary api/experience endpoint
export const restEndpoint = import.meta.env.VITE_CORE_REST_ENDPOINT
export const graphqlUriPrimary = `${restEndpoint}/graphql`
